<template>
  <InputContainer :label="label">
    <BaseTextInput
      placeholder="YYYY-MM-DD"
      pattern="\d{4}-\d{2}-\d{2}"
      :value="value"
      @input="$emit('input', $event)"
    >
      <template #append>
        <BaseIcon name="event" class="cal-icon" />
        <q-popup-proxy
          ref="dateMenu"
          transition-show="scale"
          transition-hide="scale"
          anchor="center right"
          self="center left"
        >
          <q-date
            today-btn
            no-unset
            color="our-purple"
            mask="YYYY-MM-DD"
            :model-value="value"
            @update:model-value="updateValue"
            :options="dateOptions"
          >
            <span v-if="noLimitBlocked" class="free-text">{{ $t("setting.freeDates") }}</span>
          </q-date>
        </q-popup-proxy>
      </template>
    </BaseTextInput>
    <BaseTooltip v-if="tooLateError" always-show is-error>
      {{ $t("setting.freeDates") }}
    </BaseTooltip>
  </InputContainer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import InputContainer from './InputContainer'
import BaseTextInput from './BaseTextInput'
import BaseIcon from '@/components/BaseIcon'
import BaseTooltip from '@/components/BaseTooltip'
import { dateIsOldEnough } from '@/helpers/validate'
import { NO_LIMIT_SITES } from '../../constants/sites'

const { mapGetters } = createNamespacedHelpers('searchSettings')


export default {
  components: {
    InputContainer,
    BaseTextInput,
    BaseIcon,
    BaseTooltip,
  },
  props: {
    label: String,
    placeholder: String,
    value: String
  },
  computed: {
    ...mapGetters(['websites']),
    noLimitBlocked () {
      let activeSites = []
      activeSites = this.websites.filter(site => site.active)
      // make sure that the active sites are only the ones that are not in the NO_LIMIT_SITES array
      activeSites = activeSites.filter(site => !NO_LIMIT_SITES.includes(site.name))
      if (activeSites.length === 0) {
        return false
      }
      return true
    },
    tooLateError () {
      let activeSites = []
      activeSites = this.websites.filter(site => site.active)
      // make sure that the active sites are only the ones that are not in the NO_LIMIT_SITES array
      activeSites = activeSites.filter(site => !NO_LIMIT_SITES.includes(site.name))
      if (activeSites.length === 0) {
        return false
      }
      return !this.dateOptions(this.value)
    },
  },
  methods: {
    updateValue (newValue) {
      this.$emit('input', newValue)
      this.$refs.dateMenu.hide()
    },
    dateOptions (date) {
      let activeSites = []
      activeSites = this.websites.filter(site => site.active)
      // make sure that the active sites are only the ones that are not in the NO_LIMIT_SITES array
      activeSites = activeSites.filter(site => !NO_LIMIT_SITES.includes(site.name))
      if (activeSites.length === 0) {
        return true
      }
      return dateIsOldEnough(date)
    },
  },
  emits: ['input']
}
</script>

<style lang="scss">
.free-text {
  font-family: var(--primary-font);
}
</style>

<style scoped lang="scss">
.cal-icon {
  cursor: pointer;
}
</style>
